import { Sprout, Microscope, Package, Ship } from "lucide-react";
import { useReveal } from "../hooks/useReveal";

const ITEMS = [
    {
        icon: Sprout,
        title: "Direct from farms",
        body: "We work hand-in-hand with 1,200+ farmers across Andhra Pradesh, Telangana and Tamil Nadu — no middlemen, full traceability.",
    },
    {
        icon: Microscope,
        title: "Lab-tested quality",
        body: "Every consignment is tested for moisture, ASTA colour, SHU, curcumin, and microbial load before it leaves our facility.",
    },
    {
        icon: Package,
        title: "Custom packaging",
        body: "Jute, PP, vacuum, and private-label retail — packed from 500g pouches to 50kg export bags with your brand.",
    },
    {
        icon: Ship,
        title: "On-time shipping",
        body: "FOB / CIF / CFR from Chennai, Krishnapatnam and Mundra. Documentation, fumigation, phyto — handled.",
    },
];

export default function WhyUs() {
    const ref = useReveal();
    return (
        <section
            id="why"
            data-testid="why-us-section"
            className="bg-neutral-bg py-24 sm:py-32"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
                <div ref={ref} className="reveal mb-14 max-w-3xl">
                    <span className="text-xs uppercase tracking-[0.22em] text-brand-red">
                        Why Choose Us
                    </span>
                    <h2 className="mt-3 font-display text-4xl font-bold tracking-[-0.025em] sm:text-6xl">
                        Built for serious importers.
                    </h2>
                </div>
                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {ITEMS.map((it) => (
                        <Feature key={it.title} {...it} />
                    ))}
                </div>
            </div>
        </section>
    );
}

function Feature({ icon: Icon, title, body }) {
    const ref = useReveal();
    return (
        <div
            ref={ref}
            data-testid={`why-card-${title.toLowerCase().replace(/\s+/g, "-")}`}
            className="reveal group rounded-3xl border border-hairline bg-white p-7 transition-all hover:-translate-y-1 hover:shadow-xl"
        >
            <span className="grid h-12 w-12 place-items-center rounded-2xl bg-brand-red/10 text-brand-red transition-colors group-hover:bg-brand-red group-hover:text-white">
                <Icon className="h-6 w-6" />
            </span>
            <h3 className="mt-5 font-display text-xl font-bold tracking-tight">
                {title}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-ink-muted">
                {body}
            </p>
        </div>
    );
}
